import { useRef, useEffect } from 'react';

/**
 * Custom hook used to add the beforeunload event listener. This hook ensures that only one
 * instance of the listener is set at a time.
 *
 * @param callback
 */
const useBeforeUnload = (callback) => {
    const ref = useRef(callback);

    useEffect(() => {
        ref.current = callback;
    }, [callback]);

    useEffect(() => {
        const onBeforeUnload = (...args) => ref.current?.(...args);
        window.addEventListener("beforeunload", onBeforeUnload);
        return () => window.removeEventListener("beforeunload", onBeforeUnload);
    }, []);
};

export default useBeforeUnload;